module.exports = __webpack_public_path__ + "static/media/master-game-336.1ec30a13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/master-game-336.jpg
// module id = 68
// module chunks = 0